import { render, staticRenderFns } from "./GoodsCategory.vue?vue&type=template&id=85019d72&"
import script from "./GoodsCategory.vue?vue&type=script&lang=js&"
export * from "./GoodsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports